<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (this.$store.getters['user/user']) {
      this.$store.dispatch('user/getAuthenticatedUser')
    }
  },
}
</script>

<style>
@import './assets/styles/main.css';
</style>
